import { useQuery } from '@tanstack/react-query';
import { adminManualReferralsApi } from '../services/adminManualReferralsApi';
import type {
  ManualReferralEntitySearchResponse,
  ManualReferralRole,
} from '../types/manual-referral.type';

export const manualReferralSearchKeys = {
  all: ['admin', 'manual-referrals', 'entity-search'] as const,
  search: (query: string, entityType?: ManualReferralRole) =>
    [...manualReferralSearchKeys.all, query.trim(), entityType ?? 'all'] as const,
};

export const useManualReferralEntitySearch = (
  query: string,
  entityType?: ManualReferralRole,
  limit = 10,
) => {
  const normalizedQuery = query.trim();

  return useQuery<ManualReferralEntitySearchResponse, Error>({
    queryKey: manualReferralSearchKeys.search(normalizedQuery, entityType),
    queryFn: () =>
      adminManualReferralsApi.searchManualReferralEntities({
        query: normalizedQuery,
        entityType,
        limit,
      }),
    enabled: normalizedQuery.length >= 2,
    staleTime: 30000,
  });
};
